import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterOutlet } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { NavTopPublic } from "../../components/nav-top-public/nav-top-public";
import { NavTopSecure } from "../../components/nav-top-secure/nav-top-secure";
import { AsideHeader } from "../../components/aside-header/aside-header";
import { NavAside } from "../../components/nav-aside/nav-aside";
import { Footer } from "../../components/footer/footer";
import { FirebaseAuthService } from "../../services/firebase-auth.service";
import { Observable } from "rxjs";
import { User } from "@angular/fire/auth";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-public-layout",
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    NavTopPublic,
    NavTopSecure,
    AsideHeader,
    NavAside,
    Footer,
  ],
  templateUrl: "./public-layout.component.html",
  styleUrls: ["./public-layout.component.scss"],
})
export class PublicLayoutComponent {
  showDrawer = false;
  user$: Observable<User | null>;

  constructor(private firebaseAuth: FirebaseAuthService) {
    this.user$ = this.firebaseAuth.user$;
  }

  toggleDrawer() {
    this.showDrawer = !this.showDrawer;
  }

  protected readonly environment = environment;
}
